/* global ReactSpringserveComponent */

const CREATIVE_PRE_APPROVAL_MODAL_ROOT_ID = 'pre-approval-modal-root';

const creativePreApprovalModalState = {
  open: false,
  creativeId: null
};

function renderCreativePreApprovalModal() {
  if (!document.getElementById(CREATIVE_PRE_APPROVAL_MODAL_ROOT_ID)) {
    return;
  }

  window.reactComponentScriptLoaded.promise.then(function() {
    ReactSpringserveComponent.renderComponent({
      componentName: 'PreApprovalModal',
      rootId: CREATIVE_PRE_APPROVAL_MODAL_ROOT_ID,
      componentProps: {
        open: creativePreApprovalModalState.open,
        creativeId: creativePreApprovalModalState.creativeId,
        setOpen: function(open) {
          creativePreApprovalModalState.open = open;
          renderCreativePreApprovalModal();
        }
      }
    });
  });
}

$(document).on('turbo:load', function() {
  creativePreApprovalModalState.open = false;
  creativePreApprovalModalState.creativeId = null;
  renderCreativePreApprovalModal();
});

$(document).on('click', '.pre-approval-cell', function() {
  const creativeId = Number($(this).data('creativeId'));
  if (!creativeId) return;

  creativePreApprovalModalState.creativeId = creativeId;
  creativePreApprovalModalState.open = true;
  renderCreativePreApprovalModal();
});
